import mitt from 'mitt';
import type { SseEventMap } from './sseTypes';

/**
 * Typovaný in-process pub/sub pro SSE eventy (mitt, ~200 B). Každý slice si věší vlastní handlery
 * (`useXxxEvents` hook s cleanup přes `off`) — transport ani tento emitter s novými eventy nerostou.
 */
export const sseEmitter = mitt<SseEventMap>();
